import genericStore from "../generic_store";
import axios from "axios";
import { config } from "@/config/constants.js";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "request_extraction",
    object: "extraction",
    header: [

      { text: "Nombre", value: "name" },
      { text: "Cantidad de pesos", value: "pesos_quantity" },
      { text: "Cantidad de coin", value: "coins_quantity" },
      { text: "CBU", value: "cbu_alias" },
      { text: "Status", value: "status" },
      { text: "Fecha de actualización", value: "updated_at" },
      { text: "Acciones", value: "actions", sortable: false }
    ]
  },
  mutations: {
    ...genericStore.mutations,
  },
  actions: {
    ...genericStore.actions,
    updateAllStatus({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        commit("request");
        axios
          .put(config.api_url + 'request_extraction_all', data)
          .then((response) => {
            commit("success");
            resolve(response.data);
          })
          .catch((error) => {
            console.log(error);
            commit("error");
            reject(error);
          });
      });
    },
  },
  getters: {
    ...genericStore.getters
  }
};
